import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import Admissionleft from './Admissoinleft';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';
import Scholarshipleft from './Scholarshipleft'

function BonafidesScholarshipFormsEle() {

    const [datesOpen, setDatesOpen] = useState(true);
    const [guidelinesOpen, setGuidelinesOpen] = useState(false);
    
    
    const handleClick = (event) => {
        setDatesOpen(false);
        setGuidelinesOpen(false);       
        event(true);
    }

    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-5'>
                        <Scholarshipleft activeIndex={3} />
                    </Col>

                    <Col md={8} className='c-right text-center'>

                        <div className="c-heading">
                            <h3>Bonafides & Scholarship Forms</h3> <br />
                        </div>
                        
                        <Row className='mb-5'>
                            {/* /backup xs={6} sm={4} md={3} lg={3}/ */}
                            <Col xs={6} sm={6} md={6} lg={6} className="mb-3">
                                <Button className='btn-sm'
                                    onClick={() => handleClick(setDatesOpen)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={datesOpen}>
                                    Help Documents
                                </Button>
                            </Col>

                            <Col xs={6} sm={6} md={6} lg={6} className="mb-3">
                                <Button className='btn-sm '
                                    onClick={() => handleClick(setGuidelinesOpen)}
                                    aria-controls="c-guidelines"
                                    aria-expanded={guidelinesOpen}>
                                   Google Form
                                </Button>
                            </Col>

                        </Row>


                        {/*dates */}
                    <div>
                        {datesOpen && <Fade in={datesOpen}>
                                <div className='lower-content'>
                                    <div id="services" className=" services-area fix col-lg-12 col-md-12">
                                        <div className="services-box text-left">
                                            <h4><p>Help Documents</p></h4>
                                            
                                            <div className="services-content2">
                                                <b>User Manual : </b> <Link to="https://files.iittp.ac.in/pdfs/Awardees/2022-2023/Help Doc.pdf" className="c-link">Click Here</Link>
                                            </div>
                                        </div>
                                    </div>  
                            </div>
                        </Fade>
                    }
                    </div>


                        {/*Guidelines*/}
                        
                    <div>
                            {guidelinesOpen && <Fade in={guidelinesOpen}>
                                <div className='lower-content'>
                                    <div id="services" className=" services-area fix col-lg-12 col-md-12">
                                        <div className="services-box text-left">
                                            <h4><p>Forms</p></h4>

                                            <div className="services-content2">
                                                <b>Google Forms :</b> <Link to="https://forms.gle/22ARcJWnBc2MsBVg8" className="c-link">Click Here</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </Fade>
                    }
                </div>
            </Col>
        </Row>
    </Container>
        </section>
    );
}

export default BonafidesScholarshipFormsEle;
